import { createSlice } from '@reduxjs/toolkit';
import { getProduttori, getProduttoriCategoria } from './operations';
import {
  createAsyncState,
  handlePending,
  handleFulfilled,
  handleRejected,
} from '../base';

const initialState = {
  produttori: [],
  produttoriCategoria: [],
  getProduttoriAction: createAsyncState(),
  getProduttoriCategoriaAction: createAsyncState(),
};

const produttoriSlice = createSlice({
  name: 'produttori',
  initialState,

  extraReducers: builder => {
    builder
      .addCase(getProduttori.pending, state => {
        handlePending(state.getProduttoriAction);
      })
      .addCase(getProduttori.fulfilled, (state, action) => {
        state.produttori = action.payload;
        handleFulfilled(state.getProduttoriAction, action);
      })
      .addCase(getProduttori.rejected, (state, action) => {
        handleRejected(state.getProduttoriAction, action);
      })
      .addCase(getProduttoriCategoria.pending, state => {
        handlePending(state.getProduttoriCategoriaAction);
      })
      .addCase(getProduttoriCategoria.fulfilled, (state, action) => {
        state.produttoriCategoria = action.payload;
        handleFulfilled(state.getProduttoriCategoriaAction, action);
      })
      .addCase(getProduttoriCategoria.rejected, (state, action) => {
        handleRejected(state.getProduttoriCategoriaAction, action);
      });
  },
});

export const produttoriReducer = produttoriSlice.reducer;
